<angular-editor id="navigation" [(ngModel)]="content" [config]="editorConfig" (ngModelChange)="contentChanged()"></angular-editor>
